/**
 * Product Swiper using Swiper.js Library
 * Features: Vertical thumbnails on left, counter, progress bar, arrows, synced sliders
 */
class ProductSwiper {
  constructor(container) {
    this.container = container;
    this.init();
  }
  
  init() {
    // Initialize thumbnail slider first
    this.thumbsSwiper = new Swiper(this.container.querySelector('.product-swiper__thumbs'), {
      spaceBetween: 4,
      slidesPerView: 'auto',
      freeMode: true,
      watchSlidesProgress: true,
      direction: 'vertical',
      breakpoints: {
        0: {
          direction: 'horizontal',
          slidesPerView: 'auto',
        },
        769: {
          direction: 'vertical',
          slidesPerView: 'auto',
        }
      }
    });

    // Initialize main slider
    this.mainSwiper = new Swiper(this.container.querySelector('.product-swiper__main'), {
      spaceBetween: 0,
      loop: true,
      navigation: {
        nextEl: this.container.querySelector('.product-swiper__arrow--next'),
        prevEl: this.container.querySelector('.product-swiper__arrow--prev'),
      },
      thumbs: {
        swiper: this.thumbsSwiper,
      },
      keyboard: {
        enabled: true,
      },
      // Mobile: slide effect instead of fade
      breakpoints: {
        0: {
          slidesPerView: 1.2,
          spaceBetween: 0,
        },
        769: {
          slidesPerView: 1,
          spaceBetween: 0,
        }
      },
      on: {
        slideChange: (swiper) => {
          this.updateCounter(swiper);
          this.updateProgressBar(swiper);
        },
        init: (swiper) => {
          this.updateCounter(swiper);
          this.updateProgressBar(swiper);
        }
      }
    });
  }
  
  updateCounter(swiper) {
    const counter = this.container.querySelector('.product-swiper__counter');
    if (counter) {
      // Use realIndex for looped sliders
      const current = swiper.realIndex + 1;
      // Get actual slide count (excluding duplicates)
      const total = swiper.slides.filter(slide => !slide.classList.contains('swiper-slide-duplicate')).length;
      counter.textContent = `${current} / ${total}`;
    }
  }

  updateProgressBar(swiper) {
    const progressBar = this.container.querySelector('.product-swiper__progress-fill');
    if (progressBar) {
      const current = swiper.realIndex + 1;
      // Get actual slide count (excluding duplicates)
      const total = swiper.slides.filter(slide => !slide.classList.contains('swiper-slide-duplicate')).length;
      // Ensure progress never exceeds 100%
      const progress = Math.min((current / total) * 100, 100);
      progressBar.style.width = `${progress}%`;
    }
  }

  destroy() {
    if (this.mainSwiper) this.mainSwiper.destroy();
    if (this.thumbsSwiper) this.thumbsSwiper.destroy();
  }
}

// Initialize all product swipers on page load
document.addEventListener('DOMContentLoaded', () => {
  const swipers = document.querySelectorAll('.product-swiper');
  swipers.forEach(container => {
    new ProductSwiper(container);
  });
});

// Export for use in theme
if (typeof theme !== 'undefined') {
  theme.ProductSwiper = ProductSwiper;
}

